module.exports = __webpack_public_path__ + "static/img/viral_12.5fb14a01.jpg";